import RudderstackController from './rudderstack_controller'

export default class FilterClickedController extends RudderstackController {
  static values = {
    location: String,
    accountType: String,
    requestAction: String,
    requestController: String,
  }

  initialize() {
    this.currentTarget = null;
    this.target = null;
  }

  track(event) {
    this.currentTarget = event.currentTarget;
    this.target = event.target;
    RudderstackController.track('Filter Clicked', this.properties());
  }

  properties() {
    const { currentTarget, locationValue, accountTypeValue } = this;
    const { filterName } = currentTarget.dataset;
    const { requestAction, requestController } = window.TeePublic;
    const cartId = currentTarget.dataset.cartId;
    const filterLabel = this.filterLabel();

    return {
      account_type: accountTypeValue,
      cart_id: cartId,
      filter_name: filterName,
      filter_option_label: filterLabel,
      location: locationValue,
      request_action: requestAction,
      request_controller: requestController,
    }
  }

  dasheryTrack(event) {    
    this.currentTarget = event.currentTarget;
    this.target = event.target;
    RudderstackController.track('Filter Clicked', this.dasheryProperties());
  }

  dasheryProperties() {
    const { currentTarget, locationValue, accountTypeValue, requestActionValue, requestControllerValue } = this;
    const { filterName } = currentTarget.dataset;
    const cartId = currentTarget.dataset.cartId;
    const filterLabel = this.filterLabel();

    return {
      account_type: accountTypeValue,
      cart_id: cartId,
      filter_name: filterName,
      filter_option_label: filterLabel,
      location: locationValue,
      request_action: requestActionValue,
      request_controller: requestControllerValue,
    }
  }

  filterLabel() {
    if (this.productConfigEvent()) return this.productConfigFilterLabel();
    if (this.dasheryAdminMarketingEvent()) return this.dasheryAdminMarketingValue().toString();

    const filter = this.currentTarget;
    const { tagName, dataset } = filter;
    return tagName === 'SELECT'
      ? filter.selectedOptions[0].textContent
      : dataset.filterOptionLabel || filter.innerText;
  }

  productConfigEvent() {
    return this.locationValue === 'product_attributes';
  }

  productConfigFilterLabel() {
    const { target } = this;
    const { tagName, value } = target;
    const { inputType } = target.dataset;

    if (tagName === 'SELECT') return target.selectedOptions[0].textContent;

    if (inputType === 'increment') {
      return target.parentElement.querySelector('input[type="number"]').value;
    }

    if (target.type === 'number') return value;

    const labelElement = document.querySelector(`label[for="${this.target.id}"]`);
    return labelElement.title || labelElement.textContent.trim();
  }

  dasheryAdminMarketingEvent() {
    return this.locationValue === 'my_account'
  }

  dasheryAdminMarketingValue() {
    switch(this.currentTarget.dataset.filterName) {
      case 'collect_email_on_checkout':
        return document.getElementById('marketing-checkout-checkbox').checked
      case 'show_subscribe_on_site':
        return document.getElementById('marketing-footer-checkbox').checked
    }
  }
}
